import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { Entity, Metadata } from "../../core/components/commonApp";
import { Grid } from "../../core/components/grid";
import { Translation } from "../../core/components/skills";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { UebersetungInGrid } from "../editTranslationsInGrid";
import { EditDocumentCategoriesProps } from "./editDocumentCategoriesGrid";
import EditDocumentSubCategory, { EditDocumentSubCategoryProps } from "./editDocumentSubCategory";
import React from "react";
export default class EditDocumentSubCategoriesGrid extends React.Component<EditDocumentCategoriesProps, {
    vm: SubDocumentCategoriesViewModel;
    gridData: SubDocumentCategoryViewModel[];
    selectedItem: SubDocumentCategoryViewModel;
}>{

    constructor(props) {
        super(props);
        this.state = {
            gridData: null,
            selectedItem: null,
            vm: null
        }
    }

    componentDidMount() {
        this.loadData();
    }

    private loadData = async () => {
        let result = await HTTPService.get<JsonResultClass<SubDocumentCategoriesViewModel>>("SubDocumentsSettings/GetAllSubCategories");
        if (result.Code == 0) {
            this.setState({ vm: result.Data, gridData: result.Data.SubCategories });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private _handleSelectedChange = (dataItem: SubDocumentCategoryViewModel) => {
        this.setState({ selectedItem: dataItem });
    }

    private createNewEntity = (): SubDocumentCategoryViewModel => {
        let entity: SubDocumentCategoryViewModel = {
            Translations: [],
            IsNew: true,
            IsWatchable: true,
            IsWatched: true,
            RecordRight: { CanRead: true, CanWrite: true }
        };
        return entity;
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: SubDocumentCategoryViewModel) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this.openEditSubCategory(dataItem)
                break;
            case (ToolBarStandardButtonType.NEW):
                let newEntity = this.createNewEntity();
                this.openEditSubCategory(newEntity);
                break;
            case (ToolBarStandardButtonType.DELETE):
                this.deleteSubCategory(dataItem.Id);
                break;
        }
    }

    private openEditSubCategory = (dataItem: SubDocumentCategoryViewModel = null) => {
        HTTPService.chainBatch
            .add<Metadata>(Helper.getMetaData("documentSubCategory"))
            .promise()
            .then(result => {
                const metadata = result[0];
                this.initWindow(dataItem, metadata);
            });
    }

    private initWindow = (entity: SubDocumentCategoryViewModel, metaData: any) => {
        const props: EditDocumentSubCategoryProps = {
            dataSources: {},
            metadata: metaData as Metadata,
            entity: entity,
            isWindow: true,
            context: {},
            title: ""
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, () => {
            this.loadData();
        });
        sheet.show(() => {
            sheet.mountContent(EditDocumentSubCategory, props);
        });
    }

    private deleteSubCategory = async (id: number) => {
        let isOk = await DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]);
        if (isOk) {
            let result = await HTTPService.post<JsonResultClass>("SubDocumentsSettings/DeleteSubCategory?id=" + encodeURIComponent(id));
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                this.loadData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: Helper.hasValue(this.state.selectedItem) && this.state.selectedItem.IsDeleteable });
        let grid = (
            <Grid data={this.state.gridData} options={this.props.context.subDocumentCategoriesGridOptions} id="subDocumentCategoriesGrid"
                onSelectionChanged={this._handleSelectedChange} standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} />
        );
        return <div style={{ height: "300px" }}>
            {grid}
        </div>
    }

    render() {
        let grid = Helper.hasValue(this.state.gridData) ? this.createGrid() : null;

        return (<>
            {grid}
        </>)
    }
}

export interface SubDocumentCategoriesViewModel {
    UsedLanguages?: Translation[];
    SubCategories?: SubDocumentCategoryViewModel[];
}

export interface SubDocumentCategoryViewModel extends Entity {
    Id?: number;
    KategoryId?: number;
    OriginalBezeichnung?: string;
    TranslatedBezeichnung?: string;
    IsRowId?: number;
    IsDeleteable?: boolean;
    Translations?: UebersetungInGrid[];
}